import { render, staticRenderFns } from "./TraveldocPage.vue?vue&type=template&id=69f33f7d&"
import script from "./TraveldocPage.vue?vue&type=script&lang=js&"
export * from "./TraveldocPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports